<template>
    <div class="px-4 py-4 main-container sm:px-6">
        <div class="h-full">
            <div class="h-full md:grid md:grid-cols-3 md:gap-3">
                <div class="md:col-span-1">
                    <h3 class="text-lg font-medium leading-6 text-gray-900">
                        {{ patient.first_name }} {{ patient.last_name }}
                    </h3>
                    <div class="px-4 py-5 mt-5 bg-white border-t border-gray-200 sm:px-6">
                        <div class="flex flex-row-reverse flex-wrap items-center justify-between -mt-4 -ml-4 sm:flex-no-wrap">
                            <div class="flex-shrink-0 mt-4 ml-4">
                                <span class="inline-flex rounded-md shadow-sm">
                                    <button
                                        @click="print"
                                        type="button"
                                        class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white bg-teal-600 border border-transparent rounded-md hover:bg-teal-500 focus:outline-none focus:shadow-outline-teal focus:border-teal-700 active:bg-teal-700"
                                    >
                                        Stampa Ricetta
                                    </button>
                                </span>
                                <span class="inline-flex rounded-md shadow-sm">
                                    <button
                                        @click="save"
                                        type="button"
                                        class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
                                    >
                                        Salva
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-5 scrollable md:mt-0 md:col-span-2">
                    <div class="grid grid-cols-6 gap-3">
                        <div class="sm:col-span-6">
                            <files
                                :patient_id="patient.id"
                                :examination_id="examination.id"
                            ></files>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Files from "./Files";

export default {
    data: () => {
        return {
            loaded: false
        };
    },

    components: {
        Files
    },

    computed: {
        ...mapState("examination", ["examination"]),
        ...mapState("patient", ["patient"])
    },

    methods: {
        print() {
            this.$store.dispatch("examination/PRINT", {
                patient: this.patient,
                examination: this.examination
            });
        },
        save() {
            this.$store.dispatch("examination/SAVE", this.examination);
        },
        destroy() {
            if (confirm("Sicuro di voler cancellare la visita?")) {
                this.$store.dispatch("examination/DELETE");
                this.$router.go(-1);
            }
        }
    }
};
</script>
